import { useLocation } from 'react-router-dom';
const NotFound = () => {
  const { pathname } = useLocation();
  return <div>
    {`${pathname} - Route not found`}
  </div>
}

export default NotFound;